module.exports = __webpack_public_path__ + "img/wenda.83129f44.png";